import { BasketState } from '@websrc/Typings/DanteBasket'
import React, { ReactNode, useContext, useMemo, useState } from 'react'

import { BasketAPIContext, BasketStateContext } from './BasketContext'
import { createBasketApi } from './createBasketApi'

export interface BasketStateProviderProps {
  children: ReactNode
  enable: boolean
}

export const BasketStateProvider = ({ children, enable }: BasketStateProviderProps) => {
  const [basketState, setBasketState] = useState<BasketState | undefined>()

  const basketApi = useMemo(() => createBasketApi(enable, setBasketState), [enable])

  return (
    <BasketAPIContext.Provider value={basketApi}>
      <BasketStateContext.Provider value={basketState}>{children}</BasketStateContext.Provider>
    </BasketAPIContext.Provider>
  )
}

export const useBasketStateOptional = (): BasketState | undefined => {
  return useContext(BasketStateContext)
}

export const useBasketState = (): BasketState => {
  const basketState = useContext(BasketStateContext)

  if (!basketState) {
    throw Error('Basket state not fetched yet')
  }

  return basketState
}
